export enum PERF {
	PERF_BAD = 0,
	PERF_LOW = 1,
	PERF_GOOD = 2,
	PERF_HIGH = 3,
}
